import { combineReducers } from 'redux';

import accountModal from 'store/slice/accountModalSlice';
import auth from 'store/slice/authSlice';
import buyBar from 'store/slice/buyBarSlice';
import cmsBanner from 'store/slice/cmsBannerSlice';
import featureFlags from 'store/slice/featureFlagsSlice';
import homepage from 'store/reducers/homepageReducer';
import pageLayout from 'store/slice/pageLayoutSlice';
import pdp from 'store/slice/pdpSlice';
import pdpState from 'store/slice/pdpStateSlice';
import search from 'store/slice/searchSlice';
import { apiSlice } from 'store/api/apiSlice';

export default combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  accountModal,
  auth,
  buyBar,
  cmsBanner,
  featureFlags,
  homepage,
  pageLayout,
  pdp,
  pdpState,
  search,
});
